import { Menu } from 'antd';
import React, { useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import { ROLES } from '../../constants';
import './Main.scss';
import { useFeatureFlags } from '../../modules/feature-flags/feature-flags.hook';
import { NotificationBadge } from '../ui/notification-badge.tsx';

const getCountLabel = (active) => {
  if (active > 0) {
    return active > 99 ? '99+' : active.toString();
  }
  return '';
};

const MainMenu = ({ history, user, activeUnseenCount }) => {
  const {
    location: { pathname },
  } = history;

  const { featureFlags } = useFeatureFlags();

  let selectedKey = pathname;

  const paths = useMemo(
    () => ({
      home: `/home`,
      riders: `/riders`,
      companies: `/companies`,
      users: `/users`,
      vehicles: `/vehicles`,
      performance: `/performance`,
      orders: `/orders`,
      settings: `/settings`,
      pricing: `/pricing`,
      ['message-logs']: `/message-logs`,
      routes: `/routes`,
      issues: `/issues`,
      serviceLevel: '/service-level',
      sustainability: '/sustainability',
    }),
    [featureFlags],
  );
  if (selectedKey.includes('riders') && !selectedKey.includes('routes')) {
    selectedKey = paths.riders;
  } else if (selectedKey.includes('vehicles')) {
    selectedKey = paths.vehicles;
  } else if (selectedKey.includes('users')) {
    selectedKey = paths.users;
  } else if (selectedKey.includes('orders') && !selectedKey.includes('routes')) {
    selectedKey = paths.orders;
  } else if (selectedKey.includes('companies')) {
    selectedKey = paths.companies;
  } else if (selectedKey.includes('routes')) {
    selectedKey = paths.routes;
  } else if (selectedKey.includes('settings')) {
    selectedKey = paths.settings;
  } else if (selectedKey.includes('pricing')) {
    selectedKey = paths.pricing;
  } else if (selectedKey.includes('message-logs')) {
    selectedKey = paths['message-logs'];
  } else if (selectedKey.includes('home')) {
    selectedKey = paths['home'];
  } else if (selectedKey.includes('issues')) {
    selectedKey = paths['issues'];
  } else if (selectedKey.includes('service-level')) {
    selectedKey = paths['serviceLevel'];
  } else if (selectedKey.includes('sustainability')) {
    selectedKey = paths['sustainability'];
  }
  if (!user) return null;

  // const roleAccess = {
  //   [paths.routes]: [ROLES.ADMIN],
  //   [paths.orders]: [ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER],
  //   [paths.companies]: [ROLES.ADMIN],
  //   [paths.riders]: [ROLES.ADMIN],
  //   [paths.vehicles]: [ROLES.ADMIN],
  //   [paths.users]: [ROLES.ADMIN],
  //   [paths.settings]: [ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER],
  // };

  const base = [
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/dashboard.svg" />
          <Link to={paths.home}>Home</Link>
        </div>
      ),
      key: paths.home,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/orders.svg" />
          <Link to={paths.orders}>Orders</Link>
        </div>
      ),
      key: paths.orders,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/companies.svg" />
          <Link to={paths.companies}>Companies</Link>
        </div>
      ),
      key: paths.companies,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/analytics.svg" />
          <Link to={`${paths.performance}`}>Performance</Link>
        </div>
      ),
      key: paths.performance,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/analytics.svg" />
          <Link to={`${paths.serviceLevel}`}>Service Level</Link>
        </div>
      ),
      key: paths.serviceLevel,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/sustainable.svg" />
          <Link to={`${paths.sustainability}`}>Sustainability</Link>
        </div>
      ),
      key: paths.sustainability,
      visible: true,
    },
    {
      label: (
        <div className="MenuItemContent">
          {activeUnseenCount > 0 ? (
            <>
              <ReactSVG className="icon" src="/icons/issues.svg" />
              <NotificationBadge
                label={getCountLabel(activeUnseenCount)}
                className="bg-red-500 hover:bg-red-500 border-white translate-x-8 -translate-y-2 w-2/3 h-2/3 text-[10px] justify-center"
              >
                <Link to={`${paths.issues}`}>Issues</Link>
              </NotificationBadge>
            </>
          ) : (
            <>
              <ReactSVG className="icon" src="/icons/issues.svg" />
              <Link to={`${paths.issues}`}>Issues</Link>
            </>
          )}
        </div>
      ),
      key: paths.issues,
      visible: true,
    },
  ];
  const items = useMemo(() => {
    if (user.role === ROLES.COMPANY_OWNER || user.role === ROLES.LOCATION_USER) {
      return base
        .filter(
          (item) =>
            item.key.includes(paths.performance) ||
            item.key.includes(paths.orders) ||
            item.key.includes(paths.home) ||
            item.key.includes(paths.issues),
        )
        .map(({ label, key }) => ({ label, key }));
    } else if (user.role === ROLES.CARRIER_USER) {
      return base.filter((item) => [paths.home, paths.orders, paths.serviceLevel, paths.issues].includes(item.key));
    }

    return base.filter((item) => ![paths.serviceLevel].includes(item.key)).map(({ label, key }) => ({ label, key }));
  }, [featureFlags, activeUnseenCount, user]);

  //const accessibleItems = items.filter((item) => roleAccess[item.key].includes(currentAccountUser.role));

  return <Menu className={`MainMenu`} selectedKeys={[selectedKey]} mode="horizontal" items={items} />;
};

export default withRouter(MainMenu);
